// @flow
import MessageBlock from './MessageBlock';
import TextBlock from './TextBlock';
import UrlBlock from './UrlBlock';
import urlPattern from './urlPattern';

export default class MixedBlock extends MessageBlock {
  text: string;
  constructor(text: string) {
    super();
    this.text = text;
  }

  *eachPart(): Generator<TextBlock | UrlBlock, void, void> {
    let match;
    const repeatingPattern = new RegExp(urlPattern.source, 'g');
    let lastMatchIndex = 0;
    const textLength = this.text.length;
    // eslint-disable-next-line no-cond-assign
    while ((match = repeatingPattern.exec(this.text))) {
      const textSinceLastMatchedUrl = this.text.slice(lastMatchIndex, match.index);
      if (textSinceLastMatchedUrl.length > 0) {
        yield new TextBlock(textSinceLastMatchedUrl);
      }
      const url = (match[0]: string);
      const matchEndIndex = (match.index: number) + url.length;
      lastMatchIndex += matchEndIndex;
      yield new UrlBlock(url);
    }
    const lastMatchedUrlWasLastThingInText = lastMatchIndex === textLength - 1;
    if (!lastMatchedUrlWasLastThingInText) {
      const lastRemainingTextBlock = this.text.slice(lastMatchIndex);
      yield new TextBlock(lastRemainingTextBlock);
    }
  }
}
